export const YuhuModules = {
  applications: 'Applications',
};

export const Operators = {
  less_than: 'less than',
  greater_than: 'greater than',
  equals: 'equals',
  is: 'is true',
  is_not: 'is not true',
};

export const Operands = {
  credit_score: 'Credit Score',
  rent_to_income: 'Rent To Income',
  unit_below_market_rent: 'Unit offered below market rent',
  lease_term_not_standard: 'Lease term not standard',
  balance_owing: 'Balance owing',
};

export const ValidOperands = {
  applications: [
    'credit_score',
    'rent_to_income',
    'unit_below_market_rent',
    'lease_term_not_standard',
    'balance_owing',
  ].map((key) => ({ value: key, label: Operands[key] })),
};

export const ValidOperators = {
  credit_score: [
    { value: 'less_than', label: 'is less than' },
    { value: 'greater_than', label: 'is greater than' },
  ],
  rent_to_income: [
    { value: 'less_than', label: 'is less than' },
    { value: 'greater_than', label: 'is greater than' },
  ],
  unit_below_market_rent: [
    { value: 'is', label: 'is true' },
    { value: 'is_not', label: 'is not true' },
  ],
  lease_term_not_standard: [
    { value: 'is', label: 'is true' },
    { value: 'is_not', label: 'is not true' },
  ],
  balance_owing: [
    { value: 'is', label: 'is true' },
    { value: 'is_not', label: 'is not true' },
  ],
};

export const ValueRequired = {
  credit_score: true,
  rent_to_income: true,
  unit_below_market_rent: false,
  lease_term_not_standard: false,
  balance_owing: false,
};

export const ValueMin = {
  credit_score: 0,
  rent_to_income: 0,
};

export const ValueMax = {
  credit_score: 800,
  rent_to_income: 100,
};

export const ValueAddonAfter = {
  credit_score: '',
  rent_to_income: '%',
};

export const Draft = 'draft';
export const Published = 'published';
export const Archived = 'archived';
export const Statuses = {
  [Draft]: 'Draft',
  [Published]: 'Published',
  [Archived]: 'Archived',
};
